import BaseApi from './BaseApi';
// import * as constantsConfig from '@/constants/config';


export default class IndexApi extends BaseApi {
  // ***************************用户指标begin***************************
  // 1.用户指标
  async selectUserTarget(info) {
    return await this.get(`screen/selectUserTarget`, info);
  }
  // 2.用户新增及活跃趋势
  async selectUserAddActivityCurrent(info) {
    return await this.get(`screen/selectUserAddActivityCurrent`, info);
  }
  // ***************************用户指标end***************************


  // ***************************车辆指标begin***************************
  // 3.车辆指标
  async selectVehicleTarget(info) {
    return await this.get(`screen/selectVehicleTarget`, info);
  }
  // 4.车辆新增及活跃趋势
  async selectVehicleAddActivityCurrent(info) {
    return await this.get(`screen/selectVehicleAddActivityCurrent`, info);
  }
  // ***************************车辆指标end***************************


  // ***************************考核指标begin***************************
  //5.获取考核指标
  async selectAssessTarget(info) {
    return await this.get(`screenAssess/selectAssessTarget`, info);
  }
  //6.获取有效换电率
  async selectProportion(info) {
    return await this.get(`screenAssess/selectProportion`, info);
  }
  //7.获取客户满意度
  async selectUserSatisfiedProportion(info) {
    return await this.get(`screenAssess/selectUserSatisfiedProportion`, info);
  }
  //8.获取月累计碳减排
  async selectCarbonReduction(info) {
    return await this.get(`screenAssess/selectCarbonReduction`, info);
  }
  //9.获取安全运营天数
  async selectOperDayProportion(info) {
    return await this.get(`screenAssess/selectOperDayProportion`, info);
  }
  // ***************************考核指标end***************************

  // ***************************运营指标begin***************************
  //10.获取商用、乘用车运营业务收入
  async selectRcvAmount(info) {
    return await this.get(`screenAssess/selectRcvAmount`, info);
  }
  // 11.获取商用、乘用车运营站点数
  async selectStationAccessAmount(info) {
    return await this.get(`screenAssess/selectStationAccessAmount`, info);
  }
  // 12.获取商用、乘用车日均换电次数
  async selectPowerChangeNumOfDay(info) {
    return await this.get(`screenAssess/selectPowerChangeNumOfDay`, info);
  }
  //13.获取换电里程等4个数据
  async selectOperTarget(info) {
    return await this.get(`screenOper/selectOperTarget`, info);
  }
  //14.获取日均换电次数等4个数据
  async selectOperDailyData(info) {
    return await this.get(`screenOper/selectOperDailyData`, info);
  }
  //16.获取日均站点负荷率
  async selectDaylyStationLoadRate(info) {
    return await this.get(`screenStationInfo/selectDaylyStationLoadRate`, info);
  }
  //17.获取站点负荷率分布
  async selectStationLoadRateDistribute(info) {
    return await this.get(`screenStationInfo/selectStationLoadRateDistribute`, info);
  }
  //23.获取电池质保
  async selectBatterysQA(info) {
    return await this.get(`screenStationInfo/selectBatterysQA`, info);
  }
  // ***************************运营指标end***************************
  // ***************************综合态势begin***************************
  //15.获取综合态势
  async selectComprehensiveSituation(info) {
    return await this.get(`screenOper/selectComprehensiveSituation`, info);
  }
  // ***************************综合态势end***************************

  
}
export const indexLeft = new IndexApi();